
// src/App.js
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");


    function reward(match_amount) {
    const amount = Number(match_amount);
    if (amount == 15000) {
      return '6.5%';
    } else if (amount > 15000 && amount <= 30000) {
      return '5%';
    } else if (amount > 30000 && amount <= 60000) {
      return '4%';
    } else if (amount > 60000 && amount <= 120000) {
      return '2.5%';
    } else if (amount > 120000 && amount <= 240000) {
      return '2%';
    } else if (amount > 240000 && amount <= 480000) {
      return '1.5%';
    } else if (amount > 480000 && amount <= 960000) {
      return '1.25%';
    } else if (amount > 960000 && amount <= 1920000) {
      return '1%';
    } else if (amount > 1920000 && amount <= 3840000) {
      return '0.80%';
    } else if (amount > 3840000 && amount <= 7680000) {
      return '0.60%';
    } else if (amount > 7680000 && amount <= 15360000) {
      return '0.45%';
    } else if (amount > 15360000 && amount <= 30720000) {
      return '0.40%';
    } else {
      return '0%';
    }
  }

  function rewardAmount(match_amount) {
    const amount = Number(match_amount);

    if (amount == 15000) {
      const result = 15000 * (6.5 / 100);
      return result
    } else if (amount == 30000) {
      const result = 30000 * (5 / 100);
      return result
    } else if (amount == 60000) {
      const result = 60000 * (4 / 100);
      return result
    } else if (amount == 120000) {
      const result = 120000 * (2.5 / 100);
      return result
    } else if (amount == 240000) {
      const result = 240000 * (2 / 100);
      return result
    } else if (amount == 480000) {
      const result = 480000 * (1.5 / 100);
      return result
    } else if (amount == 960000) {
      const result = 960000 * (1.25 / 100);
      return result
    } else if (amount == 1920000) {
      const result = 1920000 * (1 / 100);
      return result
    } else if (amount == 3840000) {
      const result = 3840000 * (0.80 / 100);
      return result
    } else if (amount == 7680000) {
      const result = 7680000 * (0.60 / 100);
      return result
    } else if (amount == 15360000) {
      const result = 15360000 * (0.45 / 100);
      return result
    } else if (amount == 30720000) {
      const result = 30720000 * (0.40 / 100);
      return result
    } else {
      return 'Your amount is less then 15000'
    }
  }


    const handleWallet = async (id, match_amt) => {
  
      const result = reward(match_amt);
      const rewardamount = rewardAmount(match_amt)
     
      try {
        const result = reward(match_amt);
        console.log("Reward result:", result);
      } catch (err) {
        console.error("Error in reward:", err);
      }
  
      try {
        const setReard = await axios.post('https://api.bigfresh.in/update-wallet', { id: id, reward: result, reward_amount: rewardamount })

            toast.success("Reward Verified successfully!", { position: "top-center" });
      } catch (error) {
        console.log(error);
           toast.error("Something went wrong", { position: "top-center" });
      }
    }

  // useEffect(() => {
  //   fetch("https://api.bigfresh.in/fetch-wallet")
  //     .then((res) => {
  //       if (!res.ok) throw new Error("Network response was not ok");
  //       return res.json();
  //     })
  //     .then((data) => {
  //       if (data.result) {
  //         setRewards(data.result);
  //         console.log(data.result)
  //       } else {
  //         setError("No rewards data found.");
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setError("Error fetching wallet data!");
  //       setLoading(false);
  //     });
  // }, []);

  const fetchWallet = async () => {
  try {
    const res = await axios.get(
      "https://api.bigfresh.in/fetch-wallet"
    );

    if (res.data.result) {
      setRewards(res.data.result);
    
    } else {
      setError("No rewards data found.");
    }

  } catch (error) {
    console.error("Failed to fetch wallet data", error);
    setError("Error fetching wallet data!");

  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  fetchWallet();
}, []);

  return (
    <div className="container mt-5">
      <h1 className="text-center  mb-4 text-success fw-bold">User Rewards</h1>

      {loading && <div className="text-center">Loading…</div>}
      {error && <div className="alert alert-danger text-center">{error}</div>}

      {!loading && !error && (
        <>
          {rewards.length === 0 ? (
            <div className="text-center">No rewards available</div>
          ) : (
            <table className="table table-bordered table-striped">
              <thead className="thead-dark">
                <tr>
                  <th>User ID</th>
                  <th>Approved Date</th>
                  <th>Match Amount</th>
                  <th>Reward %</th>
                  <th>Reward Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rewards.map((reward) => (
                  <tr key={reward.id}>
                    <td>{reward.user_id}</td>
                    <td>{reward.approved_date}</td>
                    <td>₹ {reward.match_amt}</td>
                    <td>{reward.reward}</td>
                    <td>₹ {reward.reward_amount}</td>
                  
                    <td>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleWallet(reward.id, reward.match_amt)}
                           disabled={reward.status ===  ' Verified'}
                      >
                        {reward.status === ' Verified' ? 'Verified' : 'Verify Now'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
            <ToastContainer />
    </div>
  );
}

export default App;
